import { IRoute } from "shared/interface/types";
import { healthOrderRoutes } from "./healthOrderRoute";
import { healthShelfPlanB2CRoutes } from "./shelfPlanRoute/B2CRoute";
import { healthPlanB2BRoutes } from "./shelfPlanRoute/B2BRoute";

export const HealthRoutes: IRoute[] = [...healthOrderRoutes, ...healthShelfPlanB2CRoutes, ...healthPlanB2BRoutes];
